<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="firRequestType" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">FIR Request Type</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add FIR Request Type" icon="pi pi-plus" @click="toAddFir" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Request Type" field="mcc2" class="p-text-capitalize" headerStyle="width: 35%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.mcc3 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.mcc3 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editUserRoleModalOpen(data)" />
                            <!-- <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                @click="confirmDelete(data)" /> -->
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddFir" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add FIR Request Type">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="requesttype">
                            Request Type
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="requesttype" v-model="requesttype" required="true" maxlength="150" autofocus
                            :class="{ 'p-invalid': isSubmitted && !requesttype }" />
                        <small class="p-invalid p-error" v-if="v$.requesttype.$error">{{
                            v$.requesttype.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addUserPermissionSet" style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button> -->
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit Request Type" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="requesttype">
                            Request Type
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="requesttype" v-model.trim="requesttype" required="true" maxlength="150" autofocus
                            :class="{ 'p-invalid': isSubmitted && !requesttype }" />
                        <small class="p-invalid p-error" v-if="v$.requesttype.$error">{{
                            v$.requesttype.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body"></Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editUserRole(rowData)" style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px" appendTo="body"></Button> -->
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
    <!-- confirmation modal start here -->
    <ConfirmDialog group="positioned"></ConfirmDialog>
    <!-- confirmation modal end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            firRequestType: [],
            confirm: useConfirm(),
            v$: useValidate(),
            isAddFir: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            requesttype: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
        };
    },
    validations() {
        return {
            requesttype: { required: helpers.withMessage('Please enter request type', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getFIRRequestType();
    },
    methods: {
        getFIRRequestType() {
            this.ApiService.getFIRRequestType().then((items) => {
                if (items.status === 200) {
                    this.firRequestType = items.data;
                    this.totalRecords = items.count;
                } else {
                    this.firRequestType = [];
                }
                this.loading = false;
            });
        },
        async toAddFir() {
            this.isAddFir = true;
            this.isSubmitted = false;
            this.requesttype = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addUserPermissionSet() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('mcc2', this.requesttype);
            formData.append('mcc3', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateFIRRequestType(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getFIRRequestType();
                        this.isAddFir = false;
                        this.requesttype = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editUserRoleModalOpen(data) {
            this.isEditUserRole = true;
            this.requesttype = '';
            this.rowId = data.mcc1;
            this.requesttype = data.mcc2;
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.mcc3);
        },
        editUserRole() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('mcc1', this.rowId);
            formData.append('mcc2', this.requesttype);
            formData.append('mcc3', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateFIRRequestType(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getFIRRequestType();
                        this.isEditUserRole = false;
                        this.requesttype = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        async deleteEmployeeRole(data) {
            let formData = new FormData();
            formData.append('mcc1', data.mcc1);
            this.showLoaderAddBtn = true;
            try {
                const response = await this.ApiService.removeFIRRequestType(formData);
                if (response.status === 200) {
                    this.$toast.add({ severity: 'success', summary: 'Deleted', detail: response.message, life: 3000 });
                    this.getFIRRequestType();
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                }
            } catch (error) {
                console.error("Error deleting record:", error);
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete', life: 3000 });
            } finally {
                this.showLoaderAddBtn = false;
            }
        },
        confirmDelete(data) {
            this.$confirm.require({
                group: 'positioned',
                message: 'Are you sure you want to delete this record?',
                header: 'Confirm Deletion',
                icon: 'pi pi-exclamation-triangle',
                position: 'top',
                rejectProps: {
                    label: 'Cancel',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Delete',
                    severity: 'danger'
                },
                accept: () => {
                    this.deleteEmployeeRole(data);
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: 'Cancelled', detail: 'Deletion cancelled', life: 3000 });
                }
            });
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getFIRRequestType({ page_no: event.page });
        },
    }
};
</script>